import { Widget } from '@/types/widget';
const supportedFlows = Object.values(Widget.Flow);
/**
 * Resolves the optional `flow` query param LandingView receives.
 *
 * Returns null when no flow was requested, so the caller keeps the default
 * buy/sell setup. Throws for a flow we don't support or a flow missing its
 * required params - LandingView turns that into the AccessError screen.
 */
export function resolveLandingFlow(query) {
    const flow = query.flow?.toString().trim().toLowerCase();
    if (!flow)
        return null;
    if (!supportedFlows.includes(flow)) {
        throw new Error(`[Query Params]: unsupported flow ${query.flow}`);
    }
    const txId = query.txId?.toString().trim();
    if (!txId) {
        throw new Error(`[Query Params]: flow ${flow} requires txId`);
    }
    return { flow: flow, txId };
}
export default resolveLandingFlow;
